
import { defineComponent } from "vue";

export default defineComponent({
  name: "Header",
  props: ["theme", "themeColor"],
  methods: {
    textCommand: function (command: string) {
      document.execCommand(command, false);
      this.focusContent();
    },
    handleChangeMode: function () {
      this.$emit("theme-mode");
      this.focusContent();
    },
    handleChangeColor: function () {
      this.$emit("theme-color");
      this.focusContent();
    },
    focusContent: function () {
      document.getElementById("content")?.focus();
    },
    printPage: function () {
      print();
    },
  },
});
